import React from "react";
import styled from "styled-components";
import {NextSeo} from "next-seo";

import Page from "../../../components/Page";
import AwardItem from "../../../components/AwardItem";
import {award_list, get_awards_page} from "../../../api/awards";
import PageHero from "../../../components/PageHero";

const Container = styled.div`
  display: block;
  overflow: hidden;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 910px;
  margin: 50px auto;
`;

const AwardsList = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
`;

class Awards extends React.Component {
  render() {
    return (
      <Page>
        <NextSeo title="Awards" description="Awards." />
        <Container>
          <PageHero page={this.props.page} />
          <Content>
            <AwardsList>
              {this.props.awards.map(award => (
                <AwardItem key={award.slug} award={award} />
              ))}
            </AwardsList>
          </Content>
        </Container>
      </Page>
    );
  }
}

export async function getServerSideProps(context) {
  try {
    const language = context.locale || "en";
    const res = await award_list(language);
    const page = await get_awards_page(language);
    const awards = res || [];

    return {
      props: {
        awards,
        page,
      },
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
    };
  }
}

export default Awards;
